<template>
    <all-topics type="participate" />
</template>

<script>
import AllTopics from './All'

export default {
    components: { AllTopics },
    name: 'Partin',
}
</script>
